import React from 'react';
import { UsersIcon } from 'lucide-react';
const PulseDot = () => <div className="relative flex h-2.5 w-2.5 flex-shrink-0" data-id="element-784">
    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#FF4080] opacity-75" data-id="element-785"></span>
    <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-[#FF4080]" data-id="element-786"></span>
  </div>;
export function ZonePulseWidget() {
  return <div className="bg-white border border-border rounded-xl p-4" data-id="element-787">
      <div className="flex items-center gap-3" data-id="element-788">
        <PulseDot data-id="element-789" />
        <div className="flex-1 min-w-0" data-id="element-790">
          <div className="flex items-center gap-2 mb-0.5" data-id="element-791">
            <span className="text-sm font-semibold text-foreground" data-id="element-792">
              Zona attiva ora
            </span>
            <span className="text-[10px] font-medium text-[#FF4080] bg-[#FF4080]/10 px-1.5 py-0.5 rounded-full" data-id="element-793">
              LIVE
            </span>
          </div>
          <p className="text-xs text-muted-foreground" data-id="element-794">
            <span className="font-medium text-foreground" data-id="element-795">12 host</span> nella
            tua zona hanno check-out oggi ·
            <span className="font-medium text-[#FF4080]" data-id="element-796"> 6 opportunità</span>{' '}
            di sharing disponibili
          </p>
        </div>
        <div className="flex-shrink-0 flex items-center gap-1 text-xs text-muted-foreground" data-id="element-797">
          <UsersIcon size={14} data-id="element-798" />
          <span className="font-semibold text-foreground" data-id="element-799">12</span>
        </div>
      </div>
    </div>;
}